// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commutably {
  --checkbox-margin: 0.7em 0 0.3em;
  --checkbox-padding-inside: 0.7em;
  --checkbox-invalid-focus-outline-color: var(--color-red-2);
}
`, "",{"version":3,"sources":["webpack://./src/theme/components/Checkbox.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,0DAA0D;AAC5D","sourcesContent":[".commutably {\n  --checkbox-margin: 0.7em 0 0.3em;\n  --checkbox-padding-inside: 0.7em;\n  --checkbox-invalid-focus-outline-color: var(--color-red-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
